import { Trans } from '@lingui/react/macro'
import { t } from '@lingui/core/macro'

import { Button } from '@jotta/ui/Button'
import { cn } from '@jotta/utils/css'

import { showToast } from '../../Toasts/ToastProvider'
import { FormInputText } from '../FormInputText/FormInputText'

interface CopyInputProps {
  value: string
  buttonText?: string
  onCopy: () => void
  className?: string
  testId?: string
}

export const CopyInputFragment: React.FC<CopyInputProps> = ({
  value,
  buttonText,
  onCopy,
  testId,
}) => {
  const copyHandler = () => {
    navigator.clipboard
      .writeText(value)
      .then(onCopy)
      .catch(reason => {
        showToast({
          message: t`Copy to clipboard failed`,
          hasCloseButton: true,
        })
        reportError(reason)
      })
  }

  return (
    <>
      <FormInputText
        type="text"
        readOnly
        value={value}
        data-testid={testId || 'CopyInput'}
      />
      <Button
        type="button"
        onClick={copyHandler}
        data-testid={`${testId || 'CopyInput'}-Button`}
        className="btn btn-primary"
      >
        {buttonText || <Trans>Copy</Trans>}
      </Button>
    </>
  )
}
export const CopyInput: React.FC<CopyInputProps> = props => {
  return (
    <div className={cn('flex gap-2', props.className)}>
      <CopyInputFragment {...props} />
    </div>
  )
}
